(() => {
  'use strict';

  const VERSION = '11.86';
  const api = window.AONSK_INTEGRATED_PLANNERS;
  const Planner = api?.__test?.GardenPlanner;
  if (!Planner || Planner.prototype.__aonsk1186) return;
  const proto = Planner.prototype;
  proto.__aonsk1186 = true;

  const esc = (value = '') => String(value).replace(/[&<>'"]/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[ch]));

  function ensure(planner) {
    planner.state.version = VERSION;
    planner.state.spaces = (planner.state.spaces || []).map(space => ({
      rainfallObservationStart: '',
      rainfallObservationEnd: '',
      ...space
    }));
  }

  function sourceGuide() {
    return `<section class="aonsk-input-map" aria-label="How to complete this stage">
      <header><div><p class="aonsk-edu-eyebrow">Start with what you know</p><h3>One bed, four clearly separated kinds of information</h3></div><p>The bed layout stays visible. Soil opens first. The more specialized panels remain available below without placing every input on screen at once.</p></header>
      <div>
        <article class="is-site"><span>1</span><div><strong>Bed essentials</strong><small>Name, size, sunlight, support, and planting depth.</small></div></article>
        <article class="is-soil"><span>2</span><div><strong>Soil</strong><small>Use a laboratory report or direct observation. Regional maps are not substituted for this bed.</small><a href="https://websoilsurvey.nrcs.usda.gov/" target="_blank" rel="noopener">Optional USDA regional context</a></div></article>
        <article class="is-water"><span>3</span><div><strong>Water</strong><small>Current gauge-period rainfall and actual delivery capacity—not future rainfall.</small></div></article>
        <article class="is-observation"><span>4</span><div><strong>Local observations</strong><small>Microclimate, pests, scouting, and repeated seasonal conditions.</small></div></article>
      </div>
      <p class="aonsk-input-map__boundary"><strong>Long-term rainfall:</strong> NOAA monthly normals describe a typical year. <strong>Measured rainfall:</strong> your gauge total describes only the dated period you enter. <strong>Forecast:</strong> not connected.</p>
    </section>`;
  }

  const baseRender = proto.render;
  proto.render = function () {
    ensure(this);
    const result = baseRender.call(this);
    ensure(this);
    this.root.querySelector('.aonsk-planner-app')?.classList.add('aonsk-planner-app--v1186');
    return result;
  };

  const baseSpaceCard = proto.spaceCard;
  proto.spaceCard = function (space, index) {
    let html = baseSpaceCard.call(this, space, index);
    html = html
      .replace('Measured recent rainfall (in)', 'Rain-gauge total for this measurement period (in)')
      .replace('Use a rain gauge or a value you deliberately choose; this is separate from stored water.', 'Enter the total from a rain gauge or a deliberately chosen observation. It is used for this dated period only and never becomes a future rainfall forecast.')
      .replace('Matches the product-page interpreter fields and applies them to this bed.', 'Uses the same laboratory fields as the product-page interpreter. Regional soil maps remain context, not a substitute for this bed.')
      .replace(/(<details class="aonsk-bed-input-panel aonsk-bed-input-panel--(?:microclimate|water|advanced-soil|capacity|pests)") open>/g, '$1>');
    return html;
  };

  const baseStepSpaces = proto.stepSpaces;
  proto.stepSpaces = function () {
    return baseStepSpaces.call(this)
      .replace('<div class="aonsk-planner-space-list">', `${sourceGuide()}<div class="aonsk-planner-space-list">`)
      .replace('Record the exact bed microclimate before soil and irrigation. Unknown, rainfall-only, and no-irrigation answers are valid and remain visible in the plan.', 'Start with the visible bed essentials and soil section. Open the colored water, microclimate, pest, or advanced-report panels only when they apply; unknown and no-irrigation answers remain valid.');
  };

  const baseStepSoilWater = proto.stepSoilWater;
  proto.stepSoilWater = function () {
    return baseStepSoilWater.call(this)
      .replaceAll('Entered rainfall', 'Gauge-period rainfall')
      .replaceAll('Estimated captured rain', 'Captured rain from this gauge period')
      .replaceAll('Difference with effective entered rain', 'Weekly comparison difference')
      .replaceAll('effective entered rain', 'weekly-equivalent effective rain');
  };

  const baseEnhancedPlanText = proto.enhancedPlanText;
  proto.enhancedPlanText = function () {
    const text = baseEnhancedPlanText.call(this);
    const lines = ['', 'RAINFALL MEASUREMENT PERIODS'];
    this.state.spaces.forEach(space => {
      lines.push(`- ${space.name}: ${space.rainfallMeasuredIn === 0 || space.rainfallMeasuredIn ? `${space.rainfallMeasuredIn} in` : 'no gauge total entered'}; period ${space.rainfallObservationStart || 'start not entered'} to ${space.rainfallObservationEnd || 'end not entered'}. This observation is not used as a future rainfall average.`);
    });
    lines.push('- Future-month context comes from the sourced NOAA monthly climate normals; those normals are not a forecast for the plan year.');
    return text.includes('\nCROPS BY BED') ? text.replace('\nCROPS BY BED', `${lines.join('\n')}\n\nCROPS BY BED`) : `${text}\n${lines.join('\n')}`;
  };

  window.AONSK_GARDEN_BUILDER_1186 = { version: VERSION };
  const refresh = () => document.querySelector('[data-planner-page="garden"] [data-planner-step].is-active')?.click();
  queueMicrotask(refresh);
  setTimeout(refresh, 0);
})();
